<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-medieval-christian-hippocratic-oath">
<h1>The Medieval Christian Hippocratic Oath</h1>
<p><em>Blessed be God the Father of our Lord Jesus Christ who is blessed for ever and ever; I lie not. I will bring no stain upon the learning of the medical art. Neither will I give poison to anybody though asked to do so, nor will I suggest such a plan. Similarly, I will not give treatment to women to cause abortion neither from above nor below. But I will teach this art to those who require to learn it, without grudging and without an indenture. I will use treatment to help the sick according to my ability and judgment. And in purity and in holiness I will guard my art. Into whatsoever houses I enter, I will do so to help the sick, keeping myself free from all wrongdoing, intentional or unintentional, tending to death or to injury and from fornication with bond or free, man or woman. Whatsoever in the course of practice I see or hear (or outside my practice in social intercourse) that ought not to be published abroad, I will not divulge, but consider such things to be holy secrets. Now if I keep this oath and break it not, may God be my helper in my life and art, and may I be honoured among all men for all time. If I keep faith, well; but if I forswear myself may the opposite befall me.</em></p>
<p><img alt="" class="img-centre" src="media/file0.jpg" style="width:4.4517in;height:6.58681in"/></p>
<p style="text-align: center;"><em>English manuscript c. 1292 Circulation pf the blood.</em></p>
<p style="text-align: center;"><em>Bodleian Library, University of Oxford</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?41e2c3ce